"use client";
import FallbackImage from "@/app/components/elements/FallbackImage";

interface StoreDescriptionProps {
  storeName: string;
  description: string;
  images?: string[];
}

const StoreDescription = ({
  storeName,
  description,
  images = [],
}: StoreDescriptionProps) => {
  const paragraphs = description.split("\n").filter((p) => p.trim());

  return (
    <section className="py-6 border-t border-gray-200">
      <div className="space-y-6">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900">
          {storeName} Hakkında
        </h2>
        {images.length > 0 && (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {images.map((image, index) => (
              <div
                key={index}
                className="relative aspect-video rounded-lg overflow-hidden"
              >
                <FallbackImage
                  src={image}
                  alt={`${storeName} ${index + 1}`}
                  fill
                  className="object-cover"
                />
              </div>
            ))}
          </div>
        )}
        <div className="space-y-4 text-gray-700 leading-relaxed">
          {paragraphs.map((paragraph, index) => {
            if (paragraph.startsWith("###")) {
              return (
                <h3
                  key={index}
                  className="text-lg font-bold text-gray-900 mt-6 mb-3"
                >
                  {paragraph.replace("###", "").trim()}
                </h3>
              );
            }
            return (
              <p key={index} className="text-sm sm:text-base">
                {paragraph}
              </p>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StoreDescription;
